import AddTracking from './Add'

export default function install(Vue) {
  Vue.component(AddTracking.name, AddTracking)
}
